<template>
  <div class="obituary-comments__create-comment-container">
    <!-- Without an order (or before it loads) the field still takes greetings and photos. -->
    <div
      class="obituary-comments__create-comment"
      v-if="!(order && isLoading)"
      :class="order && showDonate ? 'donation-support' : null"
    >
      <div
        class="obituary-comments__input-button obituary-comments__field"
        v-if="activeView !== 'timeline'"
      >
        <button
          class="obituary-comments__field-text"
          type="button"
          @click.prevent="toggleModal(FORM_INITIAL)"
          v-text="createGreetingText"
        />
        <button
          class="obituary-comments__field-media"
          type="button"
          v-if="showFieldMedia"
          :aria-label="isMobile ? texts.createComment.uploadMedia : null"
          @click.prevent="toggleModal(MEDIA_INITIAL)"
        >
          <svg aria-hidden="true" class="icon">
            <use href="#images" />
          </svg>
          <span v-if="!isMobile">{{ texts.createComment.uploadMedia }}</span>
        </button>
      </div>

      <button
        class="obituary-comments__icon-button"
        type="button"
        v-if="order && showDonate"
        @click.prevent="toggleModal(DONATION_INITIAL)"
        v-text="texts.common.donate"
      />

      <button
        class="obituary-comments__icon-button"
        type="button"
        v-if="order && activeView === 'timeline'"
        @click.prevent="toggleModal(MEDIA_INITIAL)"
        v-text="texts.common.addMedia"
      />
    </div>

    <div class="obituary-comments__create-comment-skeleton" v-else />
  </div>
</template>

<script>
  import { useIsMobile } from "Main/composables/useIsMobile";
  import { mapActions, mapMutations, mapState } from "vuex";
  import {
    DONATION_INITIAL,
    FORM_INITIAL,
    MEDIA_INITIAL,
  } from "../../createCommentStepsHelper";
  import { getDonationFromLocalStorage } from "../../helpers";
  import { barMiddle } from "../../highlights/bar";

  export default {
    computed: {
      ...mapState("orders", ["order", "isLoading"]),
      ...mapState("donations", [
        "isDonating",
        "donation",
        "noDonationsAllowed",
        "availableFunds",
        "gettingAvailableFunds",
      ]),

      createGreetingText() {
        return `${
          this.isMobile || this.isTablet
            ? this.texts.createComment.writeCondolenceShort
            : this.texts.createComment.writeCondolenceLong
        }…`;
      },

      createGreetingWithMediaText() {
        return this.isMobile || this.isTablet
          ? this.texts.createComment.addMediaShort
          : this.texts.createComment.addMediaLong;
      },

      iconSize() {
        return this.isMobile ? null : "lg";
      },

      showDonate() {
        return (
          !(this.noDonations || this.isMobile) && this.activeView !== "timeline"
        );
      },

      // One photo button on phones: none here while the bottom bar has one.
      showFieldMedia() {
        return !(this.isMobile && this.barMiddle === "photos");
      },
    },

    created() {
      if (this.noDonations) {
        this.setNoDonationsAllowed(true);
      } else if (!this.donation) {
        const donation = getDonationFromLocalStorage();
        if (
          donation &&
          Number.parseInt(donation.obituaryId, 10) ===
            Number.parseInt(this.orderId, 10)
        ) {
          this.setDonation(donation);
        }
      }

      if (this.orderId && !this.order) {
        this.$store.dispatch("orders/getOrder", this.orderId);
      }
    },

    data() {
      return {
        currentSite: theme_vars.currentSite,
        DONATION_INITIAL,
        FORM_INITIAL,
        MEDIA_INITIAL,
        texts: lavendlaObituary,
      };
    },

    methods: {
      ...mapMutations("donations", [
        "setDonation",
        "setPennyBridgeId",
        "setNoDonationsAllowed",
        "setDescription",
      ]),
      ...mapActions("donations", ["getAvailableFunds"]),
      ...mapActions("createComment", ["toggleModal"]),
      getDonationFromLocalStorage,
    },
    name: "CreateComment",

    props: {
      activeView: {
        default: "masonry",
        type: String,
      },
      noDonations: {
        default: false,
        type: Boolean,
      },
      orderId: {
        default: null,
        type: String,
      },
    },

    setup() {
      const { isMobile, isTablet } = useIsMobile();
      return { barMiddle, isMobile, isTablet };
    },

    watch: {
      order(updatedOrderData) {
        if (updatedOrderData?.pennybridge_id) {
          this.setPennyBridgeId(updatedOrderData.pennybridge_id);
        }

        if (updatedOrderData?.memorialFund?.description) {
          this.setDescription(updatedOrderData.memorialFund.description);
        }

        if (
          this.currentSite === "SE" &&
          !updatedOrderData?.memorialFund &&
          !this.availableFunds &&
          !this.gettingAvailableFunds
        ) {
          this.getAvailableFunds();
        }
      },
    },
  };
</script>
